/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterA = createReactComponent("outline", "letter-a", "IconLetterA", [["path", { "d": "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12", "key": "svg-0" }], ["path", { "d": "M7 13l10 0", "key": "svg-1" }]]);

export { IconLetterA as default };
//# sourceMappingURL=IconLetterA.mjs.map
